export const whatsappContacts = [
  {
    id: 'jordan',
    label: 'الأردن',
    number: '962770072863',
    display: '+962 77 007 2863',
  },
  {
    id: 'saudi',
    label: 'السعودية',
    number: '966538069132',
    display: '+966 53 806 9132',
  },
];

export const whatsappMessage = `السلام عليكم ماهر،

تواصلت معك عبر موقعك الشخصي (mahersite) وأود بدء محادثة.

• اسمي:
• نوع المشروع أو الاستفسار:
• كيف تعرفت عليك / من أين وصلت إلى الموقع؟ (مثلاً: LinkedIn، توصية، Google، إعلان...):

`;

export function buildWhatsAppUrl(number: string, message: string = whatsappMessage): string {
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
}

export function buildTelUrl(number: string): string {
  return `tel:+${number}`;
}
